import {
  getState,
  setForm,
  updateForm,
  removeForm,
  formsSelector,
  onlyIfForm,
  useSelector,
} from '../../../store.js'
import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import {showMessageToast} from '../../Header/Toast/index.js'
import {orderLineSelector, removeLines} from '../../../data/orders.js'
import {preferCartOrderLineNamesSelector} from '../../../data/company.js'
import AutoCalculateOrderTotalsCheckbox from '../AutoCalculateOrderTotalsCheckbox.js'

export const MODAL_FORM = 'confirm_order_line_delete_modal_form'

export function showConfirmOrderLineDeleteModal(orderNumber, orderLineIDs) {
  setForm(MODAL_FORM, {
    orderNumber,
    orderLineIDs,
    isSaving: false,
    serverError: null,
  })
}

export function updateModalForm(updates) {
  updateForm(MODAL_FORM, updates)
}

export function closeModal() {
  removeForm(MODAL_FORM)
}

export function modalFormSelector(state) {
  const forms = formsSelector(state)
  return forms[MODAL_FORM]
}

export async function confirm() {
  try {
    const {orderNumber, orderLineIDs} = modalFormSelector(getState())

    updateModalForm({isSaving: true, serverError: null})

    await removeLines(orderNumber, orderLineIDs)

    showMessageToast(
      `Order line${orderLineIDs.length === 1 ? '' : 's'} removed`,
    )

    closeModal()
  } catch (err) {
    updateModalForm({
      serverError: err.message || err.error_message,
      isSaving: false,
    })
  }
}

function ConfirmOrderLineDeleteModal({form}) {
  const firstLine = useSelector((state) =>
    orderLineSelector(state, {
      orderNumber: form.orderNumber,
      orderLineID: form.orderLineIDs[0],
    }),
  )
  const preferCartOrderLineNames = useSelector(preferCartOrderLineNamesSelector)

  if (!firstLine) {
    return null
  }

  const firstProductName = preferCartOrderLineNames
    ? firstLine.order_line_product_name
    : firstLine.product_name

  return (
    <ConfirmModal
      title={`Remove Order Line${form.orderLineIDs.length === 1 ? '' : 's'}`}
      onConfirm={() => confirm()}
      onCancel={() => closeModal()}
      isSaving={form.isSaving}
      error={form.serverError}
    >
      <p className="fs-01 lh-md margin-bottom-0">
        {form.orderLineIDs.length === 1 ? (
          <span>
            Do you want to remove{' '}
            <strong>
              {firstProductName} (qty: {firstLine.quantity})
            </strong>{' '}
            from this order?
          </span>
        ) : (
          <span>
            Do you want to remove{' '}
            <strong>{form.orderLineIDs.length} lines</strong> from this order?
          </span>
        )}
      </p>
      <div className="margin-top-20">
        <AutoCalculateOrderTotalsCheckbox />
      </div>
    </ConfirmModal>
  )
}

export default onlyIfForm(ConfirmOrderLineDeleteModal, modalFormSelector)
